import { render } from "./PasswordGame.vue?vue&type=template&id=a6d5452a"
import script from "./PasswordGame.vue?vue&type=script&lang=js"
export * from "./PasswordGame.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__